import styled from '@emotion/styled';

export const Container = styled.div``;

export const PreviewData = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  @media (min-width: 769px) {
    padding: 16px 20px;
    gap: 16px;
    margin-bottom: 12px;
    box-shadow: none;
  }
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const BaseWrap = styled.div`
  width: 100%;

  @media (min-width: 769px) {
    flex: 1;
    max-width: 320px;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #575757;

  span {
    color: #ff2929;
  }
`;

export const SelectWrap = styled.div`
  select {
    height: 38px;
    padding: 0 34px 0 16px;
    border-radius: 999px;
    border: 1px solid #262626;
    background-color: #fff;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
  }

  select:invalid,
  select option[value=''] {
    color: #8c8c8c;
  }
`;

export const ForecastWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  > div {
    width: 100%;
  }

  strong {
    color: #000fff;
    font-weight: 700;
  }

  @media (min-width: 769px) {
    width: auto;
    flex-shrink: 0;

    > div {
      width: auto;
    }
  }
`;

export const Divider = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    width: 100%;
    border-top: 1px dashed rgba(0, 0, 0, 0.12);
  }
`;

export const AlertMessage = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #575757;

  strong {
    font-weight: 700;
    color: #575757;
  }

  u {
    text-underline-offset: 2px;
  }
`;
